import _ from 'lodash'
import dayjs from 'dayjs'
import liff from "@line/liff";

import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
dayjs.extend(isSameOrAfter)
dayjs().isSameOrAfter(dayjs('2011-01-01')) // default milliseconds

export default defineNuxtPlugin(async (nuxtApp) => {
//   const eventStore = useEventStore();
//   const eventData = computed(() => eventStore.event);
// return
//   const hasRun = ref(false);

//   // if LIFF Exit
//   if (liff.isInClient()) {
//     return;
//   }

//   watch(() => eventData.value, (newVal) => {
//     if(!hasRun.value && newVal) {
//       hasRun.value = true;
//       const eventDate = eventData.value?.information?.date;

//       const isSameOrAfterDate = checkEventDate(eventDate)
//       const { userAgent } = navigator;

//       let targetSite = "production";

//       if(isSameOrAfterDate === true) {
//         targetSite = "beta";
//       }

//       //is localhost
//       if (window.location.href.includes("localhost")) {
//         targetSite = "local";
//       }

//       if (!liff.isInClient() && userAgent.includes("Line") && _.includes(userAgent, 'Android')) {
//         targetSite += "_liff";
//       }

//       switch (targetSite) {
//         case "production":
//         case "test":
//         case "local":
//           //do not thing
//           return;

//         case "beta":
//           return pushToWebsiteBeta();

//         case 'production_liff':
//           openProductionLiff();
//           break;

//         case 'beta_liff':
//           openBetaLiff();
//           break;
      
//         default:
//           break;
//       }
//     }
//   })

//   const checkEventDate = (eventDate: string) => {
//     const limit_date = dayjs('2025-05-15', 'YYYY-MM-DD')
//     const isSameOrAfterDate = dayjs(eventDate, 'YYYY-MM-DD').isSameOrAfter(limit_date , 'day');
//     return isSameOrAfterDate
//   };

//   const openProductionLiff = async () => {
//     useRouter().push(`/close`);
//     window.location.href = `https://liff.line.me/2004940069-RgEBgzL9`;
//   };

//   const openBetaLiff = async () => {
//     useRouter().push(`/close`);
//     window.location.href = `https://liff.line.me/22004940069-OeovEaVP`;
//   };

//   const pushToWebsiteBeta = async () => {
//     if (window.location.href.includes("app-v3")) {
//       return;
//     }

//     window.location.href = `https://app-v3.photowish.com`;
//   }
})